function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.60791 11.0996H8.01849",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.60291 9.69531L8.0187 11.0979L6.60254 12.5009",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3204 2.05152L1.69233 2.05003C1.43249 2.05003 1.22184 1.84135 1.22184 1.58374C1.22184 1.32651 1.43249 1.11783 1.69233 1.11783L13.5417 1.11597C13.8528 1.11597 14.1049 0.866177 14.1049 0.557984C14.1049 0.249791 13.8528 0 13.5417 0H1.31421C0.589707 0 0 0.584209 0 1.30196V13.0429C0 13.4145 0.304147 13.7162 0.679637 13.7162H2.12415C3.00505 15.0875 4.55169 16 6.3103 16C8.0689 16 9.61555 15.0877 10.4964 13.7164H15.3204C15.6959 13.7164 16 13.4147 16 13.0431V2.72501C16 2.35302 15.6959 2.05152 15.3204 2.05152ZM6.3103 15.07C4.0934 15.07 2.28993 13.2835 2.28993 11.0875C2.28993 10.9222 2.30044 10.7555 2.3209 10.592C2.56948 8.60392 4.28472 7.10462 6.3103 7.10462C6.82922 7.10462 7.33369 7.20097 7.81019 7.39068C9.34125 8.00074 10.3307 9.45187 10.3307 11.0875C10.3307 13.2834 8.52719 15.07 6.3103 15.07ZM14.9605 6.60113H11.279C10.583 6.60113 10.0188 6.04241 10.0188 5.35292C10.0188 4.66326 10.583 4.10434 11.279 4.10434H14.9605V6.60113V6.60113ZM10.8633 5.35292C10.8633 5.64828 11.1049 5.88803 11.4034 5.88803C11.702 5.88803 11.9436 5.64828 11.9436 5.35292C11.9436 5.05719 11.702 4.81782 11.4034 4.81782C11.1049 4.81782 10.8633 5.05719 10.8633 5.35292Z",
  fill: "currentColor"
});

function SvgPayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.b9d30306.svg";
export { ForwardRef as ReactComponent };